import { refreshAuthToken } from './client';

/** An agent turn keeps using the token it was sent with for every tool call, for many minutes. */
export const AGENT_TURN_TOKEN_LIFETIME_MS = 20 * 60 * 1000;

const expiryOf = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replaceAll('-', '+').replaceAll('_', '/'))) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

/** A token valid for at least `minLifetimeMs`, refreshed first when it would expire sooner. */
export async function tokenLasting(token: string, minLifetimeMs = AGENT_TURN_TOKEN_LIFETIME_MS): Promise<string> {
  const expiry = expiryOf(token);
  if (expiry === null || expiry - Date.now() > minLifetimeMs) return token;
  return (await refreshAuthToken()) ?? token;
}
